require('es6-promise').polyfill()
const Vue = require('vue');
const Vuex = require('vuex');

Vue.use(Vuex);

module.exports = new Vuex.Store({
	modules:   require('./modules'),
	state:     require('./state'),
	mutations: require('./mutations'),
	getters:   require('./getters'),
	actions:   require('./actions'),
	strict:    process.env.NODE_ENV !== 'production'
});
